import React, { useState, useRef, useEffect } from 'react';

const handleSliderChange = (e, to, from, step, setTo, setFrom) => {
    const value = parseFloat(e.target.value);
    if (e.target.name === "from") {
        if (value <= to - step)
            setFrom(Math.round(value * 100) / 100);
    }
    else if (e.target.name === "to") {
        if (value >= from + step)
            setTo(Math.round(value * 100) / 100);
    }
};
// Update the closest value (from or to) based on click
const updateTheClosestValue = (clickValue, to, from, step, setTo, setFrom, min, max) => {
    if (isNaN(clickValue) || Math.min(clickValue, to - step) < min || Math.max(clickValue, from + step) > max)
        return;
    if (Math.abs(clickValue - from) < Math.abs(clickValue - to)) {
        const clickedFrom = Math.min(clickValue, to - step);
        setFrom(Math.round(clickedFrom * 100) / 100);
    }
    else {
        const clickedTo = Math.max(clickValue, from + step);
        setTo(Math.round(clickedTo * 100) / 100);
    }
};
const RangeSlider = ({ title, min, max, step = 0.5, onRangeChange, initialFrom, initialTo }) => {
    const [from, setFrom] = useState(initialFrom || min);
    const [to, setTo] = useState(initialTo || max);
    const trackRef = useRef(null);
    const updateTrack = () => {
        const range = trackRef.current;
        if (range) {
            const fromPercent = ((from - min) / (max - min)) * 100;
            const toPercent = ((to - min) / (max - min)) * 100;
            range.style.left = `${fromPercent}%`;
            range.style.width = `${toPercent - fromPercent}%`;
        }
    };
    // Update range display when `from` or `to` changes
    useEffect(() => {
        if (onRangeChange && !isNaN(from) && !isNaN(to) && from <= to) {
            onRangeChange(from, to);
        }
        updateTrack();
    }, [from, to]);
    const sliderChange = (e) => handleSliderChange(e, to, from, step, setTo, setFrom);
    const handleTrackClick = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickPercent = (clickX / rect.width) * 100;
        const clickValue = Math.round(((clickPercent / 100) * (max - min)) / step) * step + min;
        updateTheClosestValue(clickValue, to, from, step, setTo, setFrom, min, max);
    };
    return (React.createElement("div", { "data-testid": "mbw-range-slider-container", className: "mbw-range-slider-container" },
        React.createElement("div", { "data-testid": "mbw-range-slider-title", className: "mbw-range-slider-title" }, title),
        React.createElement("div", { "data-testid": "mbw-range-slider", className: "mbw-range-slider", onClick: handleTrackClick },
            React.createElement("div", { "data-testid": "mbw-range-slider-track", className: "mbw-range-slider-track", ref: trackRef }),
            React.createElement("input", { "data-testid": "mbw-range-slider-thumb-left", type: "range", name: "from", min: min, max: max, step: step, value: from, onChange: sliderChange, className: "mbw-range-slider-thumb thumb--left" }),
            React.createElement("input", { "data-testid": "mbw-range-slider-thumb-right", type: "range", name: "to", min: min, max: max, step: step, value: to, onChange: sliderChange, className: "mbw-range-slider-thumb thumb--right" })),
        React.createElement("div", { "data-testid": "mbw-range-slider-values-container", className: "mbw-range-slider-values-container" },
            React.createElement("span", { "data-testid": "mbw-range-slider-min" }, `$${min}`),
            React.createElement("span", { "data-testid": "mbw-range-slider-current-range", className: "mbw-range-slider-current-range" }, `$${from} — ${to}`),
            React.createElement("span", { "data-testid": "mbw-range-slider-max" }, `$${max}`))));
};

export { RangeSlider as default };
//# sourceMappingURL=range_slider.js.map
